import { combineReducers } from "@reduxjs/toolkit";
import tokenReducer from "./Features/userTokenSlice";
import reloadMetricsReducer from "./Features/reloadMetricsSlice";
import userLoginReducer from "./Features/userLoginSlice";
import editScreenDataReducer from "./Features/editScreenDataSlice";
import mapScreenDataReducer from "./Features/mapScreenDataSlice";
import addContentReducer from "./Features/addContentSlice";
import editContentReducer from "./Features/editContentSlice";
import mapContentReducer from "./Features/mapContentSlice";
import searchParamsReducer from "./Features/searchParamsSlice";
import showAlertReducer from "./Features/showAlertSlice";

const rootReducer = combineReducers({
  reloadMetrics: reloadMetricsReducer,
  userToken: tokenReducer,
  userLogin: userLoginReducer,
  editScreenData: editScreenDataReducer,
  mapScreenData: mapScreenDataReducer,
  addContent: addContentReducer,
  editContent: editContentReducer,
  mapContent: mapContentReducer,
  searchParams: searchParamsReducer,
  showAlert: showAlertReducer
});

export default rootReducer;
